import { render } from "./stickynote.vue?vue&type=template&id=6d0726ef"
import script from "./stickynote.vue?vue&type=script&lang=js"
export * from "./stickynote.vue?vue&type=script&lang=js"

import "./stickynote.vue?vue&type=style&index=0&id=6d0726ef&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__